var map = {
	"./arrow-right.svg": 7700,
	"./chevron-down.svg": 6212,
	"./chevron-left-gradient.svg": 6996,
	"./chevron-right.svg": 4214,
	"./close.svg": 5074,
	"./comment.svg": 3557,
	"./home.svg": 7215,
	"./like.svg": 9979,
	"./lock.svg": 9711,
	"./logo.svg": 2519,
	"./message.svg": 107,
	"./mute.svg": 6761,
	"./open.svg": 5566,
	"./pause.svg": 7196,
	"./play.svg": 9556,
	"./profile.svg": 5029,
	"./resize-full.svg": 9184,
	"./saved-like.svg": 4893,
	"./star.svg": 5198,
	"./upload.svg": 9613,
	"./volume.svg": 4972
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6669;